import { IClassroomResource } from "../../classrooms";
import { ISkillResource } from "../../skills";
import { IUserResource } from "../../users";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { IFrameworkList } from "../types";

export interface IFrameworkListQueryParameters
    extends IPaginateable, IOrderable<"title" | "createdAt" | "updatedAt" | "rncpId"> {
    filters?: {
        title?: string | null;
        rncpId?: string;
        restricted?: boolean;
        kind?: ("job" | "specific")[];
        skills?: RelationalFilter<ISkillResource>;
        classrooms?: RelationalFilter<IClassroomResource>;
        learners?: RelationalFilter<IUserResource>;
    };
}

export type IFrameworkListQueryResult = IFrameworkList;

const mapFilters = (filters: IFrameworkListQueryParameters["filters"]) => {
    const { restricted = true, title, rncpId, kind, skills, classrooms, learners } = filters ?? {};

    return {
        restricted: restricted ? 1 : undefined,
        title,
        rncpId,
        kind,
        "skills.uuid": mapRelationalFilter(skills),
        "classrooms.uuid": mapRelationalFilter(classrooms),
        "classrooms.learners.uuid": mapRelationalFilter(learners),
    };
};

export const frameworkListQuery: IApiQueryFunction<IFrameworkListQueryParameters> = ({
    filters,
    pagination,
    order,
}) => {
    return {
        method: "GET",
        url: `/frameworks${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useFrameworkListQuery = createApiQueryHook<IFrameworkListQueryParameters, IFrameworkListQueryResult>(
    frameworkListQuery,
);
